import { render, staticRenderFns } from "./setRange.vue?vue&type=template&id=5556afc7&scoped=true&"
import script from "./setRange.vue?vue&type=script&lang=js&"
export * from "./setRange.vue?vue&type=script&lang=js&"
import style0 from "./setRange.vue?vue&type=style&index=0&id=5556afc7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5556afc7",
  null
  
)

export default component.exports